import { Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { Roles } from '@plantefeve/common/constants/enums/roles.enum';
import { NO_ACCESS_ROUTE, roleGuard } from '@plantefeve/common/guards/role.guard';
import { NoAccessComponent } from './modules/no-access/no-access.component';

/** Admin menu groups (Facturen, Rapportering, Instellingen): administrators only. */
const adminOnly = { canActivate: [roleGuard], data: { roles: [Roles.Administrator] } };

export const routes: Routes = [
  {
    path: NO_ACCESS_ROUTE,
    canActivate: [AuthGuard],
    component: NoAccessComponent,
  },
  {
    path: '',
    canActivate: [AuthGuard, roleGuard],
    data: { roles: [Roles.Administrator, Roles.Planner] },
    children: [
      {
        path: 'reporting',
        ...adminOnly,
        loadChildren: () => import('./modules/reporting/reporting.routing').then((r) => r.ReportingRoutes),
      },
      {
        path: 'parameters',
        ...adminOnly,
        loadChildren: () => import('./modules/parameters/parameters.routing').then((r) => r.ParameterRoutes),
      },
      {
        path: 'relations',
        loadChildren: () => import('./modules/relations/relations.routing').then((r) => r.RelationRoutes),
      },
      {
        path: 'purchase-contracts',
        loadChildren: () =>
          import('./modules/purchase-contracts/purchase-contracts.routing').then((r) => r.PurchaseContractsRoutes),
      },
      {
        path: 'sales-contracts',
        loadChildren: () =>
          import('./modules/sales-contracts/sales-contract.routing').then((r) => r.SalesContractsRoutes),
      },
      {
        path: 'majorations',
        ...adminOnly,
        loadChildren: () => import('./modules/majorations/majorations.routing').then((r) => r.MajorationsRoutes),
      },
      {
        path: 'orders',
        loadChildren: () => import('./modules/orders/orders.routing').then((r) => r.OrderRoutes),
      },
      {
        path: 'plannings',
        loadChildren: () => import('./modules/plannings/planning.routing').then((r) => r.PlanningRoutes),
      },
      {
        path: 'articles',
        loadChildren: () => import('./modules/articles/articles.routing').then((r) => r.ArticleRoutes),
      },
      {
        path: 'stock',
        loadChildren: () => import('./modules/stock/stock.routing').then((r) => r.StockRoutes),
      },
      {
        path: 'transportations',
        ...adminOnly,
        loadChildren: () =>
          import('./modules/transportations/transportations.routing').then((r) => r.TransportationRoutes),
      },
      {
        path: 'deliveries',
        loadChildren: () => import('./modules/deliveries/deliveries.routing').then((r) => r.DeliveryRoutes),
      },
      {
        path: 'sales-invoices',
        ...adminOnly,
        loadChildren: () => import('./modules/sales-invoices/sales-invoice.routing').then((r) => r.SalesInvoicesRoutes),
      },
      {
        path: 'purchase-invoices',
        ...adminOnly,
        loadChildren: () =>
          import('./modules/purchase-invoices/purchase-invoice.routing').then((r) => r.PurchaseInvoiceRoutes),
      },
      {
        path: 'users',
        loadChildren: () => import('./modules/users/users.routing').then((r) => r.UserRoutes),
      },
    ],
  },
];
